import { capitalize } from "lodash";
import { InlineForm } from "./FilterBuilder/common"
import { useEffect, useMemo, useState } from "react";
import { Segment } from "types/Segment";
import ApiService from "services/api.service";
import { ConditionalSegmentsSettings, QueryStatementType, SegmentQueryStatement, SegmentsSettings } from "reducers/flow-builder.reducer";

/*
export interface SegmentQueryStatement {
  type: QueryStatementType.SEGMENT;
  segmentId: string;
}

export type QueryStatement =
  | AttributeQueryStatement
  | SegmentQueryStatement
  | EventQueryStatement
  | MessageEventQuery
  | Query;

export interface Query {
  type: QueryType;
  isSubBuilderChild?: boolean;
  statements: QueryStatement[];
}

export interface ConditionalSegmentsSettings {
  type: SegmentsSettingsType.CONDITIONAL;
  query: Query;
}
 */
interface SegmentSelectBoxProps {
  settings: ConditionalSegmentsSettings;
  onSettingsChange: (
    settings: ConditionalSegmentsSettings
  ) => void;
}

export const SegmentSelectBox = (props: SegmentSelectBoxProps) => {
  const [segments, setSegments] = useState<Segment[]>([]);

  const loadSegments = async () => {
    const {
      data: { data },
    } = await ApiService.get<{ data: Segment[] }>({ url: "/segments" });

    setSegments(data);
  };

  const onChange = (value: string) => {

    const updatedSettings = {
      ...props.settings,
      query: {
        ...props.settings.query,
        statements: [
          {
            type: QueryStatementType.SEGMENT,
            segmentId: value,
          },
        ],
      }
    };
    props.onSettingsChange(updatedSettings as ConditionalSegmentsSettings);
  }

  useEffect(() => {
    loadSegments();
  }, []);

  const segmentOptions = useMemo(() => {
    const options = segments.map((segment) => ({
      key: segment.id,
      title: segment.name,
    }));
    return options
  }, [segments]);

  const selectedSegmentId = useMemo(() => {
    const selectedSegments = (props.settings?.query?.statements || []) as SegmentQueryStatement[];
    const foundSegmentOption = segmentOptions.find((option) => option.key === selectedSegments?.[0]?.segmentId);
    return foundSegmentOption?.key;
  }, [props.settings, segmentOptions]);

  return (
    <div className="static-form">
      <div className="font-normal text-[14px] leading-[22px]">
        All of the following conditions match
      </div>
      <div className="flex gap-1 p-2 mt-2 items-center" >
        <div className="text-[14px] leading-[22px] text-[#111827] min-w-[80px]">
          <div className="flex gap-[10px] w-[160px] items-center font-[500] text-ellipsis">
            Select Segment
          </div>
        </div>
        <div className="flex gap-[10px] relative items-center flex-wrap">
          <select
            value={selectedSegmentId}
            onChange={(event: any) => {
              onChange?.(event.target.value);
            }}
            className="w-[100px] px-[12px] py-[5px] font-inter font-normal text-[14px] min-w-[200px] leading-[22px] border border-[#E5E7EB] placeholder:font-inter placeholder:font-normal placeholder:text-[14px] placeholder:leading-[22px] placeholder:text-[#9CA3AF] rounded-sm"
          >
            {segmentOptions?.map(({ key, title }: { key: string, title: string }) => (
              <option key={key} value={key}>
                {capitalize(title)}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  )
}